import { render, staticRenderFns } from "./InquiryCategoryPopup.vue?vue&type=template&id=bf500180&scoped=true"
import script from "./InquiryCategoryPopup.vue?vue&type=script&lang=js"
export * from "./InquiryCategoryPopup.vue?vue&type=script&lang=js"
import style0 from "./InquiryCategoryPopup.vue?vue&type=style&index=0&id=bf500180&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf500180",
  null
  
)

export default component.exports